import React, { useState } from 'react';
import { connect } from 'react-redux'
import moment from 'moment'
import { View, StyleSheet, Text } from 'react-native'
import { Avatar, Input, Button, Icon } from 'react-native-elements'
import { redeem } from '../redux/actions'
import Spinner from './spiner'
import TextZ from './TextZ';

const packageColor = (p) => {
    return { color: noPackage(p) ? '#aaaaaa' : 'gold' };
}

const packageName = (p) => {
    return noPackage(p) ? 'ไม่มีแพคเกจ' : 'VIP';
}

const noPackage = (p) => {
    switch(p.toUpperCase()) {
        case '': case null: case 'NONE':
        return true;
    }

    return false;
}

const expireDate = (e) => {
    const t = moment(e)
    if (t.year > 2100) {
        return 'ตลอดชีพ'
    }

    return t.format('DD/MM/YYYY')
}

const Redeemer = (redeem, loading, title) => {
    const [code, setCode] = useState('');

    return <>
      {title ? <TextZ style={{ color: 'red', marginTop: 10, fontSize: 16 }}>{title}</TextZ> : null}
      <View style={{ flexDirection:'row', marginTop: 10, maxWidth: '80vw' }}>
        
        <View>
            <Input 
                containerStyle={{ backgroundColor: '#FFFFFF', paddingLeft: 0, paddingRight: 0 }} 
                inputContainerStyle={{ height: 25}}
                inputStyle={{ fontSize: 14, height: 18 }} 
                leftIcon={<Icon name='card-giftcard' size={14} color='#aaaaaa' style={{ margin: 0}}/>}
                placeholder='กรอกรหัส VIP'
                value={code}
                disabled={!!loading}
                variant="primary"
                onChange={e => setCode(e.target.value)}
            />
        </View>
        <View>
            <Button 
                icon={<Icon name='play-arrow' size={14} color='white'/>}
                buttonStyle={{ flex: 1, width: 35 }}
                onPress={() => redeem(code)}
                disabled={!!loading || !code}
            />
        </View>
  </View>
  <TextZ style={{ color: 'red', marginTop: 10 }}>*สมาชิกจากเว็บ VIP <br/>ให้ขอรหัสได้ที่เว็บที่ท่านเล่น</TextZ>
  </>
}

const Component = ({ name, picture, subscription, subscription_expire, redeem, loading }) => {
    const expired = moment(subscription_expire).isBefore(moment())

    return <View style={styles.container}>
        <Avatar rounded source={picture} size='large'/>
        <TextZ style={styles.name}>{name}</TextZ>
        <TextZ style={StyleSheet.flatten([styles.package, packageColor(subscription)])}>{packageName(subscription)}</TextZ>
        <TextZ style={styles.expire}>{noPackage(subscription) ? '' : expireDate(subscription_expire)}</TextZ>
        {(noPackage(subscription) || expired) ? Redeemer(code => redeem(code, name), loading, expired ? 'แพคเกจหมดอายุ' : '') : null}
        <View style={{ marginTop: 10 }}>
            {loading ? <Spinner color='#999999' /> : null}
        </View>
        <div style={{ width: '100%', borderBottom: '1px solid #dddddd',  marginTop: 10 }}/>
    </View>
}
const mapStateToProps = state => {
    return {
        name: state.auth.name,
        picture: state.auth.picture,
        subscription: state.auth.subscription,
        subscription_expire: state.auth.subscription_expire,
        loading: state.app.loading,
    };
};
const mapDispatchToProps = dispatch => {
    return {
        redeem: (code, name) => dispatch(redeem(code, name)),
    };
};
  
export default connect(mapStateToProps, mapDispatchToProps)(Component);


const styles = StyleSheet.create({
    container: {
        backgroundColor: '#ffffff',
        padding: 10,
        width: '100%',
        justifyContent: 'space-between',
        alignContent: 'center',
        alignItems: 'center',
        alignSelf: 'flex-end',
    },
    name: { 
        textAlign: 'center',
        fontSize: 16,
        fontWeight: 'bold',
        color: '#222222',
    },
    package: {
        textAlign: 'center',
        fontSize: 16,
        fontWeight: 'bold',
        color: 'gold',
    },
    expire: {
        textAlign: 'center',
        fontSize: 12,
        fontWeight: 'bold',
        color: '#777777',
    },
    main: {
        flex: 0,
    }
});
